import { track, trackCustom } from '../lib/pixel'

const STANDARD_EVENTS = new Set([
  'PageView',
  'ViewContent',
  'Search',
  'AddToCart',
  'AddToWishlist',
  'InitiateCheckout',
  'AddPaymentInfo',
  'Purchase',
  'Lead',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'Schedule',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
])

/**
 * Fire a Meta Pixel event. Standard Meta events use fbq('track', ...),
 * everything else is dispatched as a custom event.
 */
export function trackPixel(event: string, data?: Record<string, any>) {
  if (STANDARD_EVENTS.has(event)) {
    track(event, data)
  } else {
    trackCustom(event, data)
  }
}

/**
 * Fire a pixel event and then navigate to `url`. The navigation is deferred
 * very briefly so the Pixel has a chance to send its beacon before the page
 * unloads. Falls back to immediate navigation if anything goes wrong.
 *
 * @param event - Meta event name (e.g. 'InitiateCheckout')
 * @param data - Event parameters
 * @param url - Destination URL to navigate to after tracking
 */
export function trackAndNavigate(
  event: string,
  data: Record<string, any>,
  url: string,
) {
  try {
    trackPixel(event, data)
  } catch {}
  // Small defer lets fbq flush its request before unload.
  window.setTimeout(() => {
    window.location.href = url
  }, 250)
}

export { track, trackCustom }
